module.exports = __webpack_public_path__ + "img/4-3-ribbons.15201c88.jpg";